<template>
  <div class="w-full h-full overflow-hidden flex flex-col bg-white mb-20px">
    <div class="flex-1 overflow-y-auto">
      <el-table
        :id="tableId"
        :multiple="multi"
        style="width: 100%"
        v-bind="$attrs"
        v-on="$listeners"
        :ref="tableId"
        :class="{ 'hide-header': noHeader }"
      >
        <slot />
      </el-table>
    </div>
    <el-pagination
      v-if="!noPagination"
      class="h-53px flex items-center justify-center"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      :layout="layout"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    multiple: {},
    total: {},
    noPagination: {
      default: false
    },
    pageSizes: {
      default: () => [10, 20, 30, 40, 50, 100]
    },
    layout: {
      default: 'total, sizes, prev, pager, next, jumper'
    },
    hideHeader: {
      default: false
    }
  },
  data() {
    return {
      height: '300px',
      pageSize: 10,
      currentPage: 1,
      compId: ''
    }
  },
  computed: {
    multi() {
      if (this.multiple === '' || this.multiple) {
        return true
      } else {
        return false
      }
    },
    noHeader() {
      if (this.hideHeader === '' || this.hideHeader) {
        return true
      } else {
        return false
      }
    },
    tableId() {
      return `el-table_${this.$props.__ob__.dep.id}`
    }
  },
  created() {
    this.pageSize = this.pageSizes[0]
  },
  mounted() {
    // this.updateHeight()
    // window.onresize = () => {
    //   this.updateHeight()
    // }
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.pagination()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.pagination()
    },
    pagination() {
      this.$emit('pagination', {
        size: this.pageSize,
        current: this.currentPage
      })
    },
    updateHeight() {
      // 一定要使用 nextTick 来改变height 不然不会起作用
      let el = document.querySelector('#' + this.tableId)
      if (el) {
        let elParent = el.parentNode,
          pt = this.getStyle(elParent, 'paddingTop'),
          pb = this.getStyle(elParent, 'paddingBottom')
        this.$nextTick(() => {
          this.height = elParent.clientHeight - (pt + pb) + 'px'
        })
      }
    },
    getStyle(obj, attr) {
      // 兼容IE浏览器
      let result = obj.currentStyle
        ? obj.currentStyle[attr].replace('px', '')
        : document.defaultView
            .getComputedStyle(obj, null)
            [attr].replace('px', '')
      return Number(result)
    },
    getTableRef() {
      return this.$refs[this.tableId]
    }
  }
}
</script>
<style lang="scss" scoped>

::v-deep {
  .el-table {
    &.hide-header {
      thead {
        display: none;
      }
    }
    thead {
      th {
        font-size: 18px;
        font-weight: bold;
        &.el-table__cell {
          color: #000;
          background-color: #f2f2f2;
        }
      }
    }
    tbody {
      .cell {
        font-size: 17px;
      }
    }

    .el-table__empty-block {
      padding: 15px;
      text-align: left;
      display: block;
      .el-table__empty-text {
        font-size: 16px;
        line-height: 135%;
        color: var(--text-color-default);
      }
    }
  }

  .el-pagination {
    margin: 0 auto;
  }

  .el-pagination .el-select .el-input {
    width: 120px;
  }
  .el-pager {
    flex: 1;
    overflow: hidden;
    display: flex;
  }
  .el-pager li {
    flex: 1;
    vertical-align: unset;
    min-width: auto;
    width: 34px;
    height: 34px;
    line-height: 34px;
    margin: 0 3px;
    padding: 0;
    font-size: 13px;
    border-radius: 50%;
    border: 1px solid #f4e9ff;
    &.active {
      background: var(--primary-color);
      color: #fff;
    }
  }
}

</style>
